(function () {
  'use strict';

  var moneyFormat = function (value) {
    var amount = Number(value || 0) / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: 'GBP' }).format(amount);
  };

  var clamp = function (value, min, max) { return Math.max(min, Math.min(max, value)); };

  var createZoom = function (image, stage, onSwipe) {
    if (!image || !stage) return null;
    var levels = [1, 1.5, 2.7];
    var level = 0;
    var panX = 0;
    var panY = 0;
    var pointerId = null;
    var dragging = false;
    var startX = 0;
    var startY = 0;
    var startPanX = 0;
    var startPanY = 0;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchDistance = 0;
    var pinchCenter = { x: 0, y: 0 };
    var pinchStartLevel = 0;
    var touchMoved = false;

    var bounds = function () {
      var rect = stage.getBoundingClientRect();
      var maxX = Math.max(0, (rect.width * levels[level] - rect.width) / 2);
      var maxY = Math.max(0, (rect.height * levels[level] - rect.height) / 2);
      return { maxX: maxX, maxY: maxY };
    };

    var render = function () {
      var limits = bounds();
      panX = clamp(panX, -limits.maxX, limits.maxX);
      panY = clamp(panY, -limits.maxY, limits.maxY);
      image.style.transform = 'translate3d(' + panX + 'px,' + panY + 'px,0) scale(' + levels[level] + ')';
      image.dataset.galleryZoomLevel = String(level);
      image.classList.toggle('is-zoomed', level > 0);
      image.classList.toggle('is-dragging', dragging);
    };

    var reset = function () { level = 0; panX = 0; panY = 0; render(); };
    var zoomTo = function (nextLevel, clientX, clientY) {
      if (nextLevel === level) return;
      var rect = stage.getBoundingClientRect();
      var oldScale = levels[level];
      var nextScale = levels[nextLevel];
      var focalX = typeof clientX === 'number' ? clientX - (rect.left + rect.width / 2) : 0;
      var focalY = typeof clientY === 'number' ? clientY - (rect.top + rect.height / 2) : 0;
      var ratio = nextScale / oldScale;
      panX = focalX - (focalX - panX) * ratio;
      panY = focalY - (focalY - panY) * ratio;
      level = nextLevel;
      if (level === 0) { panX = 0; panY = 0; }
      render();
    };
    var zoomAt = function (clientX, clientY) {
      var nextLevel = (level + 1) % levels.length;
      if (nextLevel === 0) { reset(); return; }
      zoomTo(nextLevel, clientX, clientY);
    };
    var distance = function (touches) {
      var x = touches[0].clientX - touches[1].clientX;
      var y = touches[0].clientY - touches[1].clientY;
      return Math.sqrt((x * x) + (y * y));
    };
    var point = function (touches) { return { x: (touches[0].clientX + touches[1].clientX) / 2, y: (touches[0].clientY + touches[1].clientY) / 2 }; };

    image.addEventListener('click', function (event) {
      if (touchMoved || dragging) { touchMoved = false; return; }
      zoomAt(event.clientX, event.clientY);
    });
    image.addEventListener('pointerdown', function (event) {
      if (level === 0) return;
      pointerId = event.pointerId;
      dragging = true;
      startX = event.clientX;
      startY = event.clientY;
      startPanX = panX;
      startPanY = panY;
      image.setPointerCapture(pointerId);
      render();
    });
    image.addEventListener('pointermove', function (event) {
      if (!dragging || event.pointerId !== pointerId) return;
      panX = startPanX + event.clientX - startX;
      panY = startPanY + event.clientY - startY;
      render();
    });
    var endPointer = function (event) {
      if (event.pointerId !== pointerId) return;
      dragging = false;
      pointerId = null;
      render();
    };
    image.addEventListener('pointerup', endPointer);
    image.addEventListener('pointercancel', endPointer);
    image.addEventListener('touchstart', function (event) {
      touchMoved = false;
      if (event.touches.length === 2) {
        touchDistance = distance(event.touches);
        pinchCenter = point(event.touches);
        pinchStartLevel = level;
        event.preventDefault();
      } else if (event.touches.length === 1) {
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        startPanX = panX;
        startPanY = panY;
      }
    }, { passive: false });
    image.addEventListener('touchmove', function (event) {
      if (event.touches.length === 2) {
        var ratio = distance(event.touches) / Math.max(1, touchDistance);
        var next = clamp(Math.round(pinchStartLevel + (ratio - 1) * 2), 0, levels.length - 1);
        if (next !== level) zoomTo(next, pinchCenter.x, pinchCenter.y);
        event.preventDefault();
        touchMoved = true;
      } else if (event.touches.length === 1 && level > 0) {
        panX = startPanX + event.touches[0].clientX - touchStartX;
        panY = startPanY + event.touches[0].clientY - touchStartY;
        render();
        event.preventDefault();
        touchMoved = true;
      }
    }, { passive: false });
    image.addEventListener('touchend', function (event) {
      if (event.touches.length) return;
      if (!touchMoved && level === 0 && event.changedTouches.length) {
        var delta = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 45 && onSwipe) onSwipe(delta < 0 ? 1 : -1);
      }
    }, { passive: true });
    window.addEventListener('resize', render);
    render();
    return { reset: reset, render: render };
  };

  var initGallery = function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var counter = gallery.querySelector('[data-gallery-counter]');
    var dialog = gallery.querySelector('[data-gallery-dialog]');
    var lightbox = gallery.querySelector('[data-gallery-lightbox]');
    var dialogCounter = gallery.querySelector('[data-gallery-dialog-counter]');
    var mainStage = gallery.querySelector('[data-gallery-stage]');
    var dialogStage = gallery.querySelector('[data-gallery-dialog-stage]');
    var dialogThumbsHost = gallery.querySelector('[data-gallery-dialog-thumbs]');
    var dialogThumbs = [];
    var openButton = gallery.querySelector('[data-gallery-open]');
    var lastFocused = null;
    var index = 0;
    var initialIndex = Number(gallery.dataset.galleryInitialIndex || 0);
    if (!main) return;

    var mainZoom = createZoom(main, mainStage, function (direction) { setImage(index + direction); });
    var dialogZoom = createZoom(lightbox, dialogStage, function (direction) { setImage(index + direction); });
    var setThumbButtons = function (strip, previous, next) {
      if (!strip || !previous || !next) return;
      previous.disabled = strip.scrollLeft <= 2;
      next.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
    };
    var updateThumbButtons = function () {
      setThumbButtons(gallery.querySelector('[data-gallery-thumbs]'), gallery.querySelector('[data-gallery-thumbs-prev]'), gallery.querySelector('[data-gallery-thumbs-next]'));
      setThumbButtons(dialogThumbsHost, gallery.querySelector('[data-gallery-dialog-thumbs-prev]'), gallery.querySelector('[data-gallery-dialog-thumbs-next]'));
    };
    if (dialogThumbsHost) {
      thumbs.forEach(function (thumb, thumbIndex) {
        var clone = thumb.cloneNode(true);
        clone.classList.remove('product-gallery__thumb');
        clone.classList.add('product-gallery__dialog-thumb');
        clone.removeAttribute('data-gallery-thumb');
        clone.setAttribute('data-gallery-dialog-thumb', '');
        clone.addEventListener('click', function () { setImage(thumbIndex); });
        dialogThumbsHost.appendChild(clone);
        dialogThumbs.push(clone);
      });
    }
    var setImage = function (nextIndex) {
      var mediaCount = Math.max(1, thumbs.length);
      index = (nextIndex + mediaCount) % mediaCount;
      var thumb = thumbs.length ? thumbs[index] : null;
      if (mainZoom) mainZoom.reset();
      if (dialogZoom) dialogZoom.reset();
      if (thumb) {
        main.src = thumb.dataset.gallerySrc;
        if (thumb.dataset.gallerySrcset) main.srcset = thumb.dataset.gallerySrcset;
        if (thumb.dataset.gallerySizes) main.sizes = thumb.dataset.gallerySizes;
        main.alt = thumb.dataset.galleryAlt || main.alt;
      }
      thumbs.forEach(function (item, itemIndex) {
        var active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      dialogThumbs.forEach(function (item, itemIndex) {
        var active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      if (counter) counter.textContent = (index + 1) + ' / ' + mediaCount;
      if (dialogCounter) dialogCounter.textContent = (index + 1) + ' / ' + mediaCount;
      if (lightbox) {
        var source = thumb ? thumb.dataset.gallerySrc : main.src;
        var sourceSet = thumb ? thumb.dataset.gallerySrcset : main.srcset;
        var imageSizes = thumb ? thumb.dataset.gallerySizes : main.sizes;
        if (sourceSet) lightbox.srcset = sourceSet;
        else lightbox.removeAttribute('srcset');
        if (imageSizes) lightbox.sizes = imageSizes;
        else lightbox.removeAttribute('sizes');
        lightbox.src = source;
        lightbox.alt = (thumb && thumb.dataset.galleryAlt) || main.alt;
      }
      var strip = gallery.querySelector('[data-gallery-thumbs]');
      if (strip && thumbs[index]) thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      if (dialog && dialog.open && dialogThumbs[index]) dialogThumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };
    thumbs.forEach(function (thumb, thumbIndex) { thumb.addEventListener('click', function () { setImage(thumbIndex); }); });
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', function () { setImage(index - 1); });
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', function () { setImage(index + 1); });
    openButton?.addEventListener('click', function () {
      lastFocused = document.activeElement;
      setImage(index);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      if (!dialog.open) dialog.showModal();
      requestAnimationFrame(function () {
        setImage(index);
        updateThumbButtons();
        if (dialogZoom) dialogZoom.render();
      });
    });
    gallery.querySelector('[data-gallery-close]')?.addEventListener('click', function () { if (dialog) dialog.close(); });
    gallery.querySelector('[data-gallery-dialog-prev]')?.addEventListener('click', function () { setImage(index - 1); });
    gallery.querySelector('[data-gallery-dialog-next]')?.addEventListener('click', function () { setImage(index + 1); });
    gallery.querySelector('[data-gallery-thumbs-prev]')?.addEventListener('click', function () { gallery.querySelector('[data-gallery-thumbs]')?.scrollBy({ left: -260, behavior: 'smooth' }); });
    gallery.querySelector('[data-gallery-thumbs-next]')?.addEventListener('click', function () { gallery.querySelector('[data-gallery-thumbs]')?.scrollBy({ left: 260, behavior: 'smooth' }); });
    gallery.querySelector('[data-gallery-thumbs]')?.addEventListener('scroll', updateThumbButtons, { passive: true });
    dialogThumbsHost?.addEventListener('scroll', updateThumbButtons, { passive: true });
    gallery.querySelector('[data-gallery-dialog-thumbs-prev]')?.addEventListener('click', function () { dialogThumbsHost?.scrollBy({ left: -260, behavior: 'smooth' }); });
    gallery.querySelector('[data-gallery-dialog-thumbs-next]')?.addEventListener('click', function () { dialogThumbsHost?.scrollBy({ left: 260, behavior: 'smooth' }); });
    dialog?.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog?.addEventListener('close', function () {
      if (dialogZoom) dialogZoom.reset();
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    });
    document.addEventListener('keydown', function (event) {
      if (!dialog || !dialog.open) return;
      if (event.key === 'Escape') dialog.close();
      if (event.key === 'ArrowLeft') setImage(index - 1);
      if (event.key === 'ArrowRight') setImage(index + 1);
      if (event.key === '0') dialogZoom?.reset();
    });
    setImage(initialIndex);
    updateThumbButtons();
  };

  var initAccordions = function (root) {
    var target = window.location.hash ? document.querySelector(window.location.hash) : null;
    root.querySelectorAll('.product-accordion').forEach(function (accordion) { accordion.open = accordion.id === 'product-key-features'; });
    if (target && target.tagName === 'DETAILS') { target.open = true; setTimeout(function () { target.scrollIntoView({ block: 'start' }); }, 0); }
    root.querySelectorAll('.product-accordion').forEach(function (accordion) {
      accordion.addEventListener('toggle', function () { if (accordion.open) history.replaceState(null, '', '#' + accordion.id); });
    });
  };

  function applianceVariantInStock(option) {
    return !!option && option.dataset.available === 'true' && option.dataset.inventoryManaged === 'true' && Number(option.dataset.inventory) > 0;
  }
  var furnitureAvailability = function (option, quantity) {
    var available = option.dataset.available === 'true';
    var requestedQuantity = Math.max(1, Number(quantity) || 1);
    var stock = Number(option.dataset.inventory) || 0;
    return { available: available, quickDelivery: available && option.dataset.inventoryManaged === 'true' && stock >= requestedQuantity && stock > 0 };
  };
  var divanStickyVisible = function (bounds) {
    return bounds.height > 0 && bounds.bottom <= 0;
  };
  var initProduct = function (page) {
    var form = page.querySelector('[data-product-form]');
    if (!form) return;
    var input = form.querySelector('[data-variant-input]');
    var stockRequired = page.dataset.stockRequired === 'true';
    var furnitureInventoryProduct = page.dataset.furnitureInventoryProduct === 'true';
    var optionFor = function () { return input && input.tagName === 'SELECT' ? input.options[input.selectedIndex] : null; };
    var priceCurrent = page.querySelector('[data-price-current]');
    var priceCompare = page.querySelector('[data-price-compare]');
    var priceCompareWrap = page.querySelector('[data-price-compare-wrap]');
    var saving = page.querySelector('[data-price-saving]');
    var savingAmount = page.querySelector('[data-price-saving-amount]');
    var savingPercent = page.querySelector('[data-price-saving-percent]');
    var stickyPrice = page.querySelector('[data-sticky-price]');
    var stickyButton = page.querySelector('[data-sticky-submit]');
    var stickySize = page.querySelector('[data-sticky-size]');
    var submit = page.querySelector('[data-add-to-basket]');
    var quantity = form.querySelector('.product-form__quantity');
    var feedback = page.querySelector('[data-form-feedback]');
    var stock = page.querySelector('[data-product-stock]');
    var stockText = page.querySelector('[data-product-stock-text]');
    var stockDetail = page.querySelector('[data-product-stock-detail]');
    var ottomanServiceNote = page.querySelector('.ottoman-services--cards > p');
    var mattressSizeOptions = Array.prototype.slice.call(page.querySelectorAll('[data-mattress-size]'));
    var headboardSizeOptions = Array.prototype.slice.call(page.querySelectorAll('[data-headboard-size]'));
    var mattressDimensionOptions = Array.prototype.slice.call(page.querySelectorAll('[data-mattress-dimension-option]'));
    var mattressDimensionLabel = page.querySelector('[data-mattress-dimension-label]');
    var mattressDimensionMeasurement = page.querySelector('[data-mattress-dimension-measurement]');
    var isMattress = page.dataset.mattressProduct === 'true';
    var isOttoman = page.dataset.ottomanProduct === 'true';
    var isDivan = page.dataset.divanProduct === 'true';
    var isHeadboard = page.dataset.headboardProduct === 'true';
    var divanTotal = page.querySelector('[data-divan-total]');
    var ottomanTotal = page.querySelector('[data-ottoman-total]');
    var divanHeadboardInputs = Array.prototype.slice.call(page.querySelectorAll('[data-divan-headboard-variant]'));
    var divanMattressInputs = Array.prototype.slice.call(page.querySelectorAll('[data-divan-mattress-variant]'));
    var ottomanMattressInputs = Array.prototype.slice.call(page.querySelectorAll('[data-ottoman-mattress-variant]'));
    var divanHeadboardNotice = page.querySelector('[data-divan-headboard-notice]');
    var divanMattressNotice = page.querySelector('[data-divan-mattress-notice]');
    var ottomanMattressNotice = page.querySelector('[data-ottoman-addon-notice]');
    if (isDivan || isHeadboard) page.querySelectorAll('.product-page__stock:not([data-product-stock])').forEach(function (message) { message.remove(); });
    if (isOttoman && ottomanServiceNote) ottomanServiceNote.textContent = 'Optional services can be added in your basket.';
    if (isDivan) {
      page.querySelectorAll('.product-page__service-item strong').forEach(function (label, index) { if (index === 2) label.textContent = 'Old Bed Removal'; });
      page.querySelectorAll('.product-page__service-bar > p').forEach(function (note) { note.textContent = 'Optional services can be added in your basket.'; });
    }
    var ottomanGroups = Array.prototype.slice.call(page.querySelectorAll('[data-ottoman-group]'));
    var divanGroups = Array.prototype.slice.call(page.querySelectorAll('[data-divan-group]'));
    var ottomanDimensionCards = Array.prototype.slice.call(page.querySelectorAll('[data-ottoman-dimension-card]'));
    var ottomanState = {};
    var divanState = {};
    ottomanGroups.forEach(function (group) {
      var selected = group.querySelector('[data-ottoman-option].is-selected');
      if (selected) ottomanState[group.dataset.optionName] = selected.dataset.optionValue;
    });
    var submitting = false;
    var cartStateUncertain = false;
    var syncMattressSizeOptions = function () {
      if (!input || !mattressSizeOptions.length) return;
      mattressSizeOptions.forEach(function (button) {
        var active = button.dataset.variantId === input.value;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };
    var syncMattressDimensions = function () {
      if (!isMattress || !mattressDimensionOptions.length) return;
      var selectedSize = mattressSizeOptions.find(function (button) { return button.dataset.variantId === (input && input.value); });
      var selectedKey = selectedSize ? selectedSize.dataset.sizeKey : '';
      var selectedDimension = mattressDimensionOptions.find(function (button) { return button.dataset.sizeKey === selectedKey; }) || mattressDimensionOptions[0];
      mattressDimensionOptions.forEach(function (button) {
        var active = button === selectedDimension;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (selectedDimension && mattressDimensionLabel && mattressDimensionMeasurement) {
        mattressDimensionLabel.textContent = selectedDimension.querySelector('strong')?.textContent || 'Selected size';
        var width = selectedDimension.dataset.dimensionWidth;
        var length = selectedDimension.dataset.dimensionLength;
        var depth = selectedDimension.dataset.dimensionDepth;
        mattressDimensionMeasurement.textContent = width + ' × ' + length + ' cm' + (depth ? ' · Depth ' + depth : ' · Depth not specified for this model');
      }
    };
    var syncHeadboardSizeOptions = function () {
      if (!isHeadboard || !headboardSizeOptions.length || !input) return;
      headboardSizeOptions.forEach(function (button) {
        var active = button.dataset.variantId === input.value;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };
    function syncApplianceStock(option) {
      var available = applianceVariantInStock(option);
      var text = submitting ? 'Adding…' : cartStateUncertain ? 'Check basket' : available ? page.dataset.stockAddText : page.dataset.stockOutText;
      if (submit) { submit.disabled = !available || submitting || cartStateUncertain; submit.textContent = text; }
      if (stickyButton) { stickyButton.disabled = !available || submitting || cartStateUncertain; stickyButton.textContent = text; }
      if (quantity && quantity.type !== 'hidden') {
        var limit = Number(option && option.dataset.inventory) || 0;
        if (available) { quantity.max = String(limit); quantity.value = String(Math.min(Math.max(1, Number(quantity.value) || 1), limit)); }
        else quantity.removeAttribute('max');
      }
      if (stock && stockText) {
        stock.classList.toggle('product-page__stock--sold', !available);
        stockText.textContent = available ? page.dataset.stockInText : page.dataset.stockUnavailableText;
        var indicator = stock.querySelector('[data-caw-stock-indicator]');
        if (indicator) {
          indicator.classList.toggle('caw-stock-indicator--unavailable', !available);
          indicator.querySelector('[data-caw-stock-tick]').toggleAttribute('hidden', !available);
          indicator.querySelector('[data-caw-stock-cross]').toggleAttribute('hidden', available);
        }
        var collection = stock.querySelector('[data-product-stock-collection]');
        if (collection) collection.hidden = !available;
      }
    }
    var updateVariant = function () {
      var option = optionFor();
      if (stockRequired) syncApplianceStock(option || input);
      if (!option) return;
      var price = Number(option.dataset.price || 0);
      var compare = Number(option.dataset.compare || 0);
      var hasSaving = compare > price;
      var amount = compare - price;
      if (priceCurrent) priceCurrent.textContent = option.dataset.priceFormatted || moneyFormat(price);
      if (stickyPrice) stickyPrice.textContent = option.dataset.priceFormatted || moneyFormat(price);
      if (stickySize && (isOttoman || isDivan || isHeadboard)) stickySize.textContent = (isDivan ? divanState['Bed Size'] : isHeadboard ? option.getAttribute('data-option-1') : ottomanState['Bed Size']) || option.getAttribute('data-option-1') || '';
      if (priceCompare) { priceCompare.textContent = hasSaving ? option.dataset.compareFormatted : ''; priceCompare.hidden = !hasSaving; }
      if (priceCompareWrap) priceCompareWrap.hidden = !hasSaving;
      if (saving) saving.hidden = !hasSaving;
      if (savingAmount) savingAmount.textContent = hasSaving ? moneyFormat(amount) : '';
      if (savingPercent) savingPercent.textContent = hasSaving ? String(Math.round((amount * 100) / compare)) : '0';
      if (!stockRequired && submit) { submit.disabled = option.dataset.available !== 'true' || submitting || cartStateUncertain; submit.textContent = submitting ? 'Adding…' : cartStateUncertain ? 'Check basket' : option.dataset.available === 'true' ? 'Add to basket' : 'Sold out'; }
      if (!stockRequired && stickyButton) { stickyButton.disabled = option.dataset.available !== 'true' || submitting || cartStateUncertain; stickyButton.textContent = submitting ? 'Adding…' : cartStateUncertain ? 'Check basket' : option.dataset.available === 'true' ? 'Add to basket' : 'Sold out'; }
      var inventory = Number(option.dataset.inventory || 0);
      var inventoryManaged = option.dataset.inventoryManaged === 'true';
      var inventoryPolicy = option.dataset.inventoryPolicy || 'deny';
      var requestedQuantity = quantity && quantity.type !== 'hidden' ? Math.max(1, Number(quantity.value || 1)) : 1;
      if (inventoryManaged && (stockRequired || inventoryPolicy !== 'continue') && inventory > 0) requestedQuantity = Math.min(requestedQuantity, inventory);
      if (quantity && quantity.type !== 'hidden') {
        if (inventoryManaged && (stockRequired || inventoryPolicy !== 'continue') && inventory > 0) quantity.max = String(inventory);
        else quantity.removeAttribute('max');
        if (quantity.value !== String(requestedQuantity)) quantity.value = String(requestedQuantity);
      }
      if (furnitureInventoryProduct && stock && stockText) {
        var furnitureState = furnitureAvailability(option, requestedQuantity);
        stock.classList.toggle('product-page__stock--sold', !furnitureState.available);
        stock.querySelector('[aria-hidden="true"]').textContent = furnitureState.available ? '✓' : '!';
        stockText.textContent = furnitureState.quickDelivery ? page.dataset.furnitureQuickText : furnitureState.available ? page.dataset.furnitureOrderText : page.dataset.furnitureUnavailableText;
        if (stockDetail) stockDetail.textContent = furnitureState.quickDelivery ? page.dataset.furnitureQuickDetail : furnitureState.available ? option.dataset.furnitureOrderDetail : page.dataset.furnitureUnavailableDetail;
        if (isDivan || isOttoman) syncDivanAddOnTotals(price);
      } else if ((isMattress || isOttoman || isDivan || isHeadboard) && stock && stockText) {
        var available = option.dataset.available === 'true';
        var requiresOrder = available && ((!inventoryManaged) || inventoryPolicy === 'continue') && (inventory <= 0 || requestedQuantity > inventory);
        var quickDelivery = available && inventoryManaged && inventory > 0 && requestedQuantity <= inventory;
        stock.classList.toggle('product-page__stock--sold', !available);
        stock.querySelector('[aria-hidden="true"]').textContent = available ? '✓' : '!';
        stockText.textContent = available ? quickDelivery ? 'In Stock — Quick Delivery' : requiresOrder ? 'Available to Order' : 'Available to Order' : 'Currently unavailable';
        if (stockDetail) stockDetail.textContent = isOttoman ? (available ? quickDelivery ? 'Available for quick delivery.' : 'This Ottoman bed size is available to order. Please allow approximately 7–10 working days for fulfilment.' : 'This Ottoman bed size is currently unavailable.') : isDivan || isHeadboard ? (available ? "Made to order. Please allow approximately 7–10 working days for preparation and arrival. We'll contact you to arrange delivery or collection once it's ready." : isDivan ? 'This divan bed base configuration is currently unavailable.' : 'This headboard size is currently unavailable.') : (available ? quickDelivery ? (isMattress ? page.dataset.furnitureQuickDetail : 'Available for quick delivery.') : 'This mattress size is available to order. Please allow approximately 7–10 days for fulfilment.' : 'This mattress size is currently unavailable.');
        if (isDivan || isOttoman) syncDivanAddOnTotals(price);
      }
    };
    var syncOttomanControls = function () {
      ottomanGroups.forEach(function (group) {
        var selectedValue = ottomanState[group.dataset.optionName];
        group.querySelectorAll('[data-ottoman-option]').forEach(function (button) {
          var active = button.dataset.optionValue === selectedValue;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', String(active));
        });
      });
    };
    var selectedAddon = function (inputs) { return inputs.find(function (input) { return input.checked && input.value; }); };
    var addonSize = function (input) {
      if (!input) return '';
      if (input.dataset.addonSize) return input.dataset.addonSize;
      var small = input.parentElement && input.parentElement.querySelector('small');
      return small ? small.textContent.replace(/\s+mattress\s*$/i, '').trim() : '';
    };
    var addonName = function (input) {
      var strong = input && input.parentElement && input.parentElement.querySelector('strong');
      return strong ? strong.textContent.trim() : '';
    };
    var sizeKey = function (value) {
      var normalized = String(value || '').toLowerCase().replace(/[()\[\],.-]/g, ' ').replace(/\s+/g, ' ').trim();
      var aliases = {
        'single': 'single', 'single 3ft': 'single', '3ft': 'single',
        'small double': 'small-double', 'small double 4ft': 'small-double', '4ft': 'small-double',
        'double': 'double', 'double 4ft 6': 'double', 'double 4ft 6in': 'double', 'double 4ft6': 'double', 'double 4ft6in': 'double', '4ft 6': 'double', '4ft 6in': 'double', '4ft6': 'double', '4ft6in': 'double',
        'king': 'king', 'king 5ft': 'king', '5ft': 'king',
        'super king': 'super-king', 'super king 6ft': 'super-king', '6ft': 'super-king'
      };
      return aliases[normalized] || '';
    };
    var syncAddonSize = function (inputs, size, notice) {
      if (!inputs.length) return;
      var selected = selectedAddon(inputs);
      var targetKey = sizeKey(size);
      var selectedProduct = selected ? selected.dataset.addonProduct || addonName(selected) : '';
      var target = selected && targetKey ? inputs.find(function (candidate) {
        return candidate.value && candidate.dataset.addonAvailable === 'true' && sizeKey(addonSize(candidate)) === targetKey && (candidate.dataset.addonProduct || addonName(candidate)) === selectedProduct;
      }) : null;
      var none = inputs.find(function (candidate) { return !candidate.value; });
      inputs.forEach(function (candidate) {
        var compatible = !candidate.value || (candidate.dataset.addonAvailable === 'true' && targetKey !== '' && sizeKey(addonSize(candidate)) === targetKey);
        var label = candidate.closest('.divan-addon__choice');
        if (label) label.hidden = !compatible;
        candidate.disabled = !compatible;
        candidate.checked = candidate === (target || (!selected && none) || none);
      });
      if (notice) {
        var cleared = !!selected && !target;
        notice.textContent = cleared ? 'Your previous selection is not available in this size. It has been cleared; choose a compatible option or No Mattress/No Headboard.' : '';
        notice.hidden = !cleared;
      }
    };
    var syncDivanAddOnTotals = function (basePrice) {
      if (!isDivan && !isOttoman) return;
      var headboard = isDivan ? selectedAddon(divanHeadboardInputs) : null;
      var mattress = isDivan ? selectedAddon(divanMattressInputs) : selectedAddon(ottomanMattressInputs);
      var total = Number(basePrice || 0) + Number(headboard ? headboard.dataset.addonPrice || 0 : 0) + Number(mattress ? mattress.dataset.addonPrice || 0 : 0);
      if (divanTotal) divanTotal.textContent = moneyFormat(total);
      if (ottomanTotal) ottomanTotal.textContent = moneyFormat(total);
    };
    var addConfiguredCartItems = function (cartItems) {
      var baseline = null;
      var addAttempted = false;
      var restorePartialItems = function () {
        if (!baseline) return Promise.resolve(false);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
          if (!response.ok) throw new Error('Unable to recheck basket after a failed add.');
          return response.json();
        }).then(function (current) {
          var requestedIds = cartItems.map(function (item) { return Number(item.id); });
          var beforeByKey = {};
          var beforeByVariant = {};
          (baseline.items || []).forEach(function (item) { beforeByKey[item.key] = item.quantity; });
          (baseline.items || []).forEach(function (item) { beforeByVariant[item.variant_id] = (beforeByVariant[item.variant_id] || 0) + Number(item.quantity || 0); });
          return (current.items || []).filter(function (item) { return requestedIds.indexOf(Number(item.variant_id)) !== -1; }).reduce(function (chain, item) {
            return chain.then(function () {
              var beforeQuantity = beforeByKey[item.key] || 0;
              if (item.quantity <= beforeQuantity) return true;
              return fetch('/cart/change.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.key, quantity: beforeQuantity }) }).then(function (response) {
                if (!response.ok) throw new Error('Unable to remove a partial basket addition.');
                return true;
              });
            });
          }, Promise.resolve(true)).then(function () {
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
              if (!response.ok) throw new Error('Unable to verify basket rollback.');
              return response.json();
            });
          }).then(function (restoredCart) {
            return requestedIds.every(function (variantId) {
              var restoredQuantity = (restoredCart.items || []).reduce(function (total, item) { return Number(item.variant_id) === variantId ? total + Number(item.quantity || 0) : total; }, 0);
              return restoredQuantity === (beforeByVariant[variantId] || 0);
            });
          });
        }).catch(function () { return false; });
      };
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('Your basket could not be checked. No items were added.');
        return response.json();
      }).then(function (cart) {
        baseline = cart;
        addAttempted = true;
        return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: cartItems }) }).then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok) throw new Error(data.description || 'Shopify could not add the configured items.');
            var returnedItems = Array.isArray(data.items) ? data.items : [data];
            var allItemsConfirmed = cartItems.every(function (requested) {
              var returnedQuantity = returnedItems.reduce(function (total, added) {
                return Number(added.variant_id || added.id) === Number(requested.id) ? total + Number(added.quantity || 0) : total;
              }, 0);
              return returnedQuantity >= Number(requested.quantity || 1);
            });
            if (!allItemsConfirmed) throw new Error('Shopify did not confirm every configured item.');
            return data;
          });
        });
      }).catch(function (error) {
        if (!addAttempted) throw error;
        return restorePartialItems().then(function (restored) {
          if (!restored) {
            cartStateUncertain = true;
            throw new Error('We could not confirm the basket after the add failed. Please check your basket before trying again.');
          }
          throw new Error((error.message || 'Unable to add these items.') + ' Any partial addition was removed; please review your basket before retrying.');
        });
      });
    };
    var syncDivanImage = function () {
      if (!isDivan) return;
      var thumbs = Array.prototype.slice.call(page.querySelectorAll('[data-gallery-thumb]'));
      if (!thumbs.length) return;
      var headboard = selectedAddon(divanHeadboardInputs);
      var storage = String(divanState['Drawer Storage'] || '').toLowerCase();
      var needle = headboard ? 'with optional headboard' : storage.indexOf('no drawers') !== -1 ? 'base only' : 'storage options';
      var match = thumbs.find(function (thumb) { return String(thumb.dataset.galleryAlt || '').toLowerCase().indexOf(needle) !== -1; });
      if (match) match.click();
    };
    var syncOttomanImage = function () {
      if (!isOttoman) return;
      var size = String(ottomanState['Bed Size'] || '').toLowerCase();
      var style = String(ottomanState['Headboard Style'] || '').toLowerCase().replace('crystals', 'crystal');
      var colour = String(ottomanState['Fabric Colour'] || '').toLowerCase().replace(/^plush\s+/, '');
      var sizeNeedle = size.indexOf('single') === 0 ? 'ottoman bed single ' : 'ottoman bed small double ';
      var thumbs = Array.prototype.slice.call(page.querySelectorAll('[data-gallery-thumb]'));
      var match = thumbs.find(function (thumb) {
        var alt = String(thumb.dataset.galleryAlt || '').toLowerCase();
        var plushIndex = alt.indexOf(' plush ');
        var imageStyle = alt.indexOf(sizeNeedle) === 0 && plushIndex !== -1 ? alt.slice(sizeNeedle.length, plushIndex).replace(/\s+\d+$/, '').trim() : '';
        return imageStyle === style && alt.indexOf(sizeNeedle) === 0 && alt.indexOf('plush ' + colour) !== -1;
      });
      var main = page.querySelector('[data-gallery-main]');
      var missing = page.querySelector('[data-ottoman-image-missing]');
      if (main) main.hidden = !match;
      if (missing) missing.hidden = !!match;
      if (match) match.click();
    };
    var syncOttomanDimensions = function () {
      if (!isOttoman || !ottomanDimensionCards.length) return;
      var size = String(ottomanState['Bed Size'] || '').toLowerCase();
      var sizeKey = size.indexOf('super king') === 0 ? 'super-king' : size.indexOf('small double') === 0 ? 'small-double' : size.indexOf('double') === 0 ? 'double' : size.indexOf('king') === 0 ? 'king' : 'single';
      ottomanDimensionCards.forEach(function (card) { var selected = card.dataset.sizeKey === sizeKey; card.classList.toggle('is-selected', selected); card.setAttribute('aria-pressed', String(selected)); });
    };
    var selectOttomanDimensionCard = function (card) {
      if (!isOttoman || !card) return;
      var sizeGroup = ottomanGroups.find(function (group) { return group.dataset.optionName === 'Bed Size'; });
      if (!sizeGroup) return;
      var sizeOption = Array.prototype.slice.call(sizeGroup.querySelectorAll('[data-ottoman-option]')).find(function (button) { return sizeKey(button.dataset.optionValue) === card.dataset.sizeKey; });
      if (sizeOption && !sizeOption.disabled) sizeOption.click();
    };
    ottomanDimensionCards.forEach(function (card) {
      card.addEventListener('click', function () { selectOttomanDimensionCard(card); });
      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        selectOttomanDimensionCard(card);
      });
    });
    var applyOttomanSelection = function (skipImage) {
      if (!isOttoman || !input || input.tagName !== 'SELECT') return;
      var target = Array.prototype.slice.call(input.options).find(function (option) {
        return option.getAttribute('data-option-1') === ottomanState['Bed Size'] && option.getAttribute('data-option-2') === ottomanState['Headboard Style'] && option.getAttribute('data-option-3') === ottomanState['Fabric Colour'];
      });
      if (!target) return;
      syncAddonSize(ottomanMattressInputs, ottomanState['Bed Size'], ottomanMattressNotice);
      input.value = target.value;
      syncOttomanControls();
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (!skipImage) syncOttomanImage();
      syncOttomanDimensions();
    };
    var syncDivanControls = function () {
      divanGroups.forEach(function (group) {
        var selectedValue = divanState[group.dataset.optionName];
        group.querySelectorAll('[data-divan-option]').forEach(function (button) {
          var active = button.dataset.optionValue === selectedValue;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', String(active));
        });
      });
    };
    var applyDivanSelection = function () {
      if (!isDivan || !input || input.tagName !== 'SELECT') return;
      var target = Array.prototype.slice.call(input.options).find(function (option) {
        return option.getAttribute('data-option-1') === divanState['Bed Size'] && option.getAttribute('data-option-2') === divanState['Drawer Storage'];
      });
      if (!target) return;
      syncAddonSize(divanHeadboardInputs, divanState['Bed Size'], divanHeadboardNotice);
      syncAddonSize(divanMattressInputs, divanState['Bed Size'], divanMattressNotice);
      input.value = target.value;
      syncDivanControls();
      input.dispatchEvent(new Event('change', { bubbles: true }));
      syncDivanImage();
    };
    input?.addEventListener('change', function () { updateVariant(); syncMattressSizeOptions(); syncHeadboardSizeOptions(); syncMattressDimensions(); syncOttomanDimensions(); syncDivanControls(); });
    quantity?.addEventListener('input', updateVariant);
    quantity?.addEventListener('change', updateVariant);
    mattressSizeOptions.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!input || button.disabled) return;
        input.value = button.dataset.variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    headboardSizeOptions.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!input || button.disabled) return;
        input.value = button.dataset.variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    mattressDimensionOptions.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!input || button.disabled) return;
        var target = mattressSizeOptions.find(function (sizeButton) { return sizeButton.dataset.sizeKey === button.dataset.sizeKey; });
        if (!target || target.disabled) return;
        target.click();
        syncMattressDimensions();
      });
    });
    ottomanGroups.forEach(function (group) {
      group.querySelectorAll('[data-ottoman-option]').forEach(function (button) {
        button.addEventListener('click', function () {
          ottomanState[group.dataset.optionName] = button.dataset.optionValue;
          applyOttomanSelection();
        });
      });
    });
    divanGroups.forEach(function (group) {
      group.querySelectorAll('[data-divan-option]').forEach(function (button) {
        button.addEventListener('click', function () {
          divanState[group.dataset.optionName] = button.dataset.optionValue;
          applyDivanSelection();
        });
      });
    });
    divanHeadboardInputs.concat(divanMattressInputs, ottomanMattressInputs).forEach(function (radio) {
      radio.addEventListener('change', function () {
        var option = optionFor();
        syncDivanAddOnTotals(option ? Number(option.dataset.price || 0) : 0);
        if (isDivan) syncDivanImage();
      });
    });
    if (isOttoman && ottomanGroups.length) {
      ottomanState['Bed Size'] = 'Single (3ft)';
      ottomanState['Headboard Style'] = 'Linea';
      ottomanState['Fabric Colour'] = 'Grey';
      applyOttomanSelection(true);
    }
    if (isDivan && divanGroups.length) {
      var selectedDivanVariant = optionFor();
      divanState['Bed Size'] = selectedDivanVariant?.getAttribute('data-option-1') || divanGroups[0].querySelector('[data-divan-option].is-selected')?.dataset.optionValue || '';
      divanState['Drawer Storage'] = selectedDivanVariant?.getAttribute('data-option-2') || divanGroups[1]?.querySelector('[data-divan-option].is-selected')?.dataset.optionValue || '';
      applyDivanSelection();
    }
    if (stockRequired && quantity) quantity.addEventListener('change', updateVariant);
    syncMattressSizeOptions();
    syncHeadboardSizeOptions();
    syncMattressDimensions();
    syncOttomanDimensions();
    updateVariant();
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (stockRequired) updateVariant();
      if (!submit || submit.disabled || submitting) return;
      submitting = true;
      updateVariant();
      var selectedHeadboard = isDivan ? selectedAddon(divanHeadboardInputs) : null;
      var selectedMattress = isDivan ? selectedAddon(divanMattressInputs) : isOttoman ? selectedAddon(ottomanMattressInputs) : null;
      var mainQuantity = quantity && quantity.type !== 'hidden' ? Math.max(1, Number(quantity.value || 1)) : 1;
      var cartItems = [{ id: Number(input && input.value), quantity: mainQuantity }];
      if (selectedHeadboard) cartItems.push({ id: Number(selectedHeadboard.value), quantity: 1 });
      if (selectedMattress) cartItems.push({ id: Number(selectedMattress.value), quantity: 1 });
      var request = (isDivan || isOttoman) ? addConfiguredCartItems(cartItems) : fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      request.then(function (response) {
        if (response && response.items) return response;
        if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add this product.'); });
        return response.json();
      }).then(function () { if (feedback) feedback.innerHTML = 'Added to basket. <a href="/cart">View basket</a>'; document.dispatchEvent(new CustomEvent('caw:cart-updated')); }).catch(function (error) { if (feedback) feedback.textContent = error.message; }).finally(function () { submitting = false; updateVariant(); });
    });
    var sticky = page.querySelector('[data-sticky-add]');
    var observerTarget = isDivan ? form.querySelector('.product-form__actions') || submit : page.querySelector('.product-form__submit');
    if (sticky && stickyButton && observerTarget && 'IntersectionObserver' in window) {
      var observer;
      var mobileStickyMedia = window.matchMedia('(max-width: 767px)');
      var syncDivanSticky = function () {
        sticky.hidden = !divanStickyVisible(observerTarget.getBoundingClientRect());
      };
      var observeSubmitButton = function () {
        if (observer) observer.disconnect();
        observer = new IntersectionObserver(function (entries) { if (isDivan) syncDivanSticky(); else sticky.hidden = entries[0].intersectionRatio >= 0.1; }, {
          rootMargin: isDivan ? '0px' : mobileStickyMedia.matches ? '0px 0px -76px 0px' : '0px',
          threshold: isDivan ? 0 : 0.1
        });
        observer.observe(observerTarget);
      };
      observeSubmitButton();
      if (mobileStickyMedia.addEventListener) mobileStickyMedia.addEventListener('change', observeSubmitButton);
      else if (mobileStickyMedia.addListener) mobileStickyMedia.addListener(observeSubmitButton);
      if (isDivan) {
        var stickyFramePending = false;
        var queueDivanSticky = function () {
          if (stickyFramePending) return;
          stickyFramePending = true;
          window.requestAnimationFrame(function () { stickyFramePending = false; syncDivanSticky(); });
        };
        window.addEventListener('scroll', queueDivanSticky, { passive: true });
        window.addEventListener('resize', queueDivanSticky);
        syncDivanSticky();
      }
      var stickyRequestPending = false;
      stickyButton.addEventListener('click', function () {
        if (stickyButton.disabled || submitting || cartStateUncertain || stickyRequestPending) return;
        stickyRequestPending = true;
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () {
          stickyRequestPending = false;
          if (stickyButton.disabled || submitting || cartStateUncertain) return;
          form.requestSubmit(submit);
        }, 250);
      });
    }
  };

  var initBrandLogos = function (root) {
    root.querySelectorAll('[data-brand-logo]').forEach(function (logo) {
      var fallback = logo.parentElement ? logo.parentElement.querySelector('[data-brand-fallback]') : null;
      var showFallback = function () {
        logo.hidden = true;
        if (fallback) fallback.hidden = false;
      };
      logo.addEventListener('error', showFallback);
      if (logo.complete && logo.naturalWidth === 0) showFallback();
    });
  };

  var initRecommendations = function (section) {
    var track = section.querySelector('[data-recommendations-track]');
    var currentType = (section.dataset.productType || '').toLowerCase();
    if (track && currentType) {
      Array.prototype.slice.call(track.children).sort(function (a, b) { return Number((b.dataset.productType || '').toLowerCase() === currentType) - Number((a.dataset.productType || '').toLowerCase() === currentType); }).forEach(function (card) { track.appendChild(card); });
    }
    section.querySelector('[data-recommendations-prev]')?.addEventListener('click', function () { track?.scrollBy({ left: -track.clientWidth * .8, behavior: 'smooth' }); });
    section.querySelector('[data-recommendations-next]')?.addEventListener('click', function () { track?.scrollBy({ left: track.clientWidth * .8, behavior: 'smooth' }); });
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-product-accordions]').forEach(initAccordions);
    document.querySelectorAll('[data-product-page]').forEach(initProduct);
    document.querySelectorAll('[data-product-page]').forEach(initBrandLogos);
    document.querySelectorAll('[data-product-recommendations]').forEach(function (section) {
      initRecommendations(section);
      if (!section.dataset.url) return;
      fetch(section.dataset.url, { headers: { Accept: 'text/html' } }).then(function (response) { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); }).then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var replacement = parsed.querySelector('[data-product-recommendations]');
        if (replacement) { section.replaceWith(replacement); initRecommendations(replacement); }
      }).catch(function () { section.hidden = true; });
    });
  });
}());
